
import axios from "axios";
import { URL_BASE } from "../config/url-server";
const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")






export const getHealthTrap = async (userId) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "health-trap/get/" + userId, config)
    const user = response?.data || null;
    return user;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getList = async (page,limit,findName) => {
  const params = {page,limit,findName};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-trap/list",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const insert = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "health-trap/insert", data, config)
    const success = response?.data || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};


export const update = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "health-trap/update", data, config)
    const success = response?.data || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};



export const list = async (page, limit, findName) => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}health-trap/list?page=${page}&limit=${limit}&name=${findName}`
    const response = await axios.get(url, config)
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getGeoTrapsByLot = async (lotId) => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}health-trap/geo-traps-by-lot?lot=${lotId}`
    const response = await axios.get(url, config)
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const getGeoTrapsByFarm = async (farmId) => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}health-trap/geo-traps-by-farm?farm=${farmId}`
    const response = await axios.get(url, config)
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};






export default {
  getList,
  list,
  getHealthTrap,
  getList,
  insert,
  update,
  getGeoTrapsByLot,
  getGeoTrapsByFarm
}

